export default __webpack_public_path__ + "static/media/ic_address.68c68294.svg";